import type { ComponentProps } from 'react';
import { t } from '@/i18n/t';

/** Nur für Vorlesegeräte sichtbar (Tailwind `sr-only`). */
export function VisuallyHidden(props: ComponentProps<'span'>) {
  return <span className="sr-only" {...props} />;
}

/** Erster Halt per Tastatur: springt hinter die Navigation zum Inhalt (`#inhalt`). */
export function SkipLink({ target = '#inhalt' }: { target?: string }) {
  return (
    <a
      href={target}
      className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-50 focus:rounded-control focus:bg-accent focus:px-4 focus:py-3 focus:font-semibold focus:text-on-accent"
    >
      {t('nav.skipToContent')}
    </a>
  );
}
